import React from "react"
import Layout from "../components/layout"
import Bio from "../components/bio/bio"
import Books from "../components/books"
import SPP from "../components/spp/SppAbout"
import Research from "../components/research"
import Media from "../components/media"
import Podcast from "../components/podcast"
import Data from "../components/data"
import Contact from "../components/contact"
import SEO from "../components/seo"

const Divider = () => (
  <div style={{ width: "100%", height: "1px", background: "var(--cream-mid)" }} />
)

export default function IndexPage() {
  return (
    <Layout rootPage={true}>
      <SEO title="Home" canonical="https://agustinagiraudy.com/" />
      <Bio />
      <Divider />
      <Books />
      <Divider />
      <SPP />
      <Divider />
      <Research />
      <Divider />
      <Podcast />
      <Divider />
      <Media />
      <Divider />
      <Data />
      <Contact />
    </Layout>
  )
}
